import { Injectable } from "@angular/core";
import { BroadcastHandlerService } from "../handlers/broadcast-handler.service";

@Injectable({
  providedIn: "root",
})
export class BroadcastService {
  constructor(private BroadcastHandlerService: BroadcastHandlerService) {}

  //LIST
  getBroadcasts(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      startDate?: string;
      endDate?: string;
      facility_id?: number[];
      listView?: boolean;
      page?: number;
      perPage?: number;
      forExport?: boolean;
    },
  ) {
    return this.BroadcastHandlerService.broadcastsGet(
      masterAccountID,
      accountAppID,
      queryParams,
    );
  }

  getBroadcast(
    masterAccountID: number,
    accountAppID: number,
    broadcastID: number,
  ) {
    return this.BroadcastHandlerService.broadcastGet(
      masterAccountID,
      accountAppID,
      broadcastID,
    );
  }

  createBroadcast(
    masterAccountID: number,
    accountAppID: number,
    broadcastDTO: any,
  ) {
    return this.BroadcastHandlerService.broadcastPost(
      masterAccountID,
      accountAppID,
      broadcastDTO,
    );
  }

  deleteBroadcast(
    masterAccountID: number,
    accountAppID: number,
    broadcastID: number,
  ) {
    return this.BroadcastHandlerService.broadcastDelete(
      masterAccountID,
      accountAppID,
      broadcastID,
    );
  }

  updateBroadcast(
    masterAccountID: number,
    accountAppID: number,
    broadcastDTO: any,
  ) {
    return this.BroadcastHandlerService.broadcastPut(
      masterAccountID,
      accountAppID,
      broadcastDTO,
    );
  }

  //LIST
  getRedemptions(
    masterAccountID: number,
    accountAppID: number,
    queryParams?: {
      start?: string;
      end?: string;
      page?: number;
      perPage?: number;
    },
  ) {
    return this.BroadcastHandlerService.redemptionsGet(
      masterAccountID,
      accountAppID,
      queryParams,
    );
  }
}
